import jwtDecode from 'jwt-decode';
import {Cookies} from "react-cookie";

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser();
    if (!user) {
        return false;
    }
    return true;
}

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    /*
    const cookies = new Cookies();
    const user = cookies.get("user");
    return user ? (typeof (user) == 'object' ? user : JSON.parse(user)) : null;
    */
    const user = localStorage.getItem('user');
    return user ? (typeof (user) == 'object' ? user : JSON.parse(user)) : null;
}

const setSession = (user) => {
    let cookies = new Cookies();
    if (user) {
       // cookies.set("user", JSON.stringify(user), {path: "/"});
        localStorage.setItem('token', user.token);
        localStorage.setItem('refreshtoken', user.refreshtoken);
        localStorage.setItem('user', JSON.stringify(user));
    } else {
        //cookies.remove("user");
        localStorage.removeItem('user');
    }
}

function authHeader() {
    // return authorization header with basic auth credentials
    // let user = JSON.parse(localStorage.getItem('user'));
    let user = false;
    try {
        user = JSON.parse(localStorage.getItem('user'));
    } catch (e) {
        user = false;
    }
    if (user && localStorage.getItem('token')) {
        return {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
    } else {
        return {};
    }
}

export {isUserAuthenticated, getLoggedInUser, authHeader, setSession};
